export class NetworkStats {
  bandwidth?: number = 0
  jitter?: number = 0
  latency?: number = 0
  score?: number = 0
  region?: string
}

export class EncoderStats {
  adaptation: 'none' | 'cpu' | 'bandwidth' = 'none'  // FIXME sweep code for this
  audio_bitrate: number = 0
  cpu_usage: number = 0
  fps_in: number = 0
  fps_out: number = 0
  height: number = 0
  video_bitrate: number = 0
  width: number = 0
}

export class UserNetworkStats {
  download?: NetworkStats = new NetworkStats()
  upload?:  NetworkStats = new NetworkStats()
  encoder?: EncoderStats = new EncoderStats()
  team_id?: string = ''
}
